import SEO from "@/components/SEO";
import { PageHero, Reveal, Kicker, Section, Rich, UL, Callout } from "@/components/Bits";
import EnquiryForm from "@/components/EnquiryForm";
import { CONTACT } from "@/content/policies";

export default function Join() {
  return (
    <div data-testid="join-page">
      <SEO
        title="Join as a Middle Man"
        description="Become a verified Middle Man — an independent service provider on the Middle Man platform. KYC with Aadhaar/PAN and selfie, your own categories, radius and pricing."
        path="/join"
      />
      <PageHero
        kicker="Join as a Middle Man"
        title="Become a Middle Man."
        subtitle="Work as an independent, verified service provider — choose your categories, your work radius and your prices, and receive job requests from customers near you."
      />

      <div className="mx-auto max-w-3xl px-6 py-16 md:py-20">
        <div className="space-y-14">
          <Reveal>
            <Section title="Who can join">
              <UL items={[
                "Aged 18+ with a valid Aadhaar / PAN.",
                "Physically able to perform the services offered.",
                "Able to complete KYC: Aadhaar number + card photo, PAN number + card photo, and a live selfie for face-match.",
                "Must complete profile with categories, sub-categories, work radius, pricing and photo.",
                "Must comply with all applicable local, state and central laws while performing services.",
              ]} />
            </Section>
          </Reveal>

          <Reveal>
            <Section title="Verification before activation">
              <Rich text="Every Middle Man is verified before they can accept work. KYC information is used solely to verify that you are a real person with the right to work on the Platform — it is never shared publicly, sold or used for advertising. This is an internal platform verification, not a government certification. False, forged or fraudulent submissions result in permanent suspension and may be reported to authorities." />
            </Section>
          </Reveal>

          <Reveal>
            <Section title="Subscription and payouts">
              <UL items={[
                "Platform access for Middle Men runs on a subscription paid through Razorpay's PCI-DSS-compliant checkout — we never see or store your card number, CVV, UPI PIN or net-banking credentials.",
                "You choose ONE payout method during registration — either UPI (we store only the VPA) or bank transfer (account number, IFSC and holder name); never both.",
                "Payout details are shown only to the paying customer for direct settlement and can be removed at any time.",
              ]} />
            </Section>
          </Reveal>

          <Reveal>
            <Section title="Your responsibilities">
              <UL items={[
                "Complete each task to the best of your ability and within a reasonable time.",
                "Handle customer belongings and personal information with care and confidentiality.",
                "Do not carry, transport or handle any prohibited item.",
                "Comply with all applicable local laws, traffic rules and safety norms.",
                "Do not solicit off-platform payments to bypass the Platform.",
                "Maintain accurate categories, sub-categories, availability and pricing.",
                "For product listings: keep listings accurate, stock honest, and compliance documents valid.",
              ]} />
            </Section>
          </Reveal>

          <Reveal>
            <Callout>
              <Rich text="Middle Men are independent, self-employed service providers — not employees of Tourist Junction Private Limited. The Platform facilitates discovery, communication and orders between two independent parties." />
            </Callout>
          </Reveal>

          <Reveal>
            <div className="border border-line bg-creamalt p-8 md:p-10" data-testid="join-interest">
              <Kicker>Express your interest</Kicker>
              <h2 className="mt-5 font-serif text-2xl font-semibold tracking-tight md:text-3xl">Start onboarding</h2>
              <p className="mt-3 max-w-xl text-sm leading-relaxed text-mute">
                The Middle Man app is launching soon on the Play Store and App Store. Leave your details and our team
                will reach out with onboarding steps — or write to us directly at{" "}
                <a href={`mailto:${CONTACT.email}`} className="font-semibold text-brand">{CONTACT.email}</a>.
              </p>
              <div className="mt-8">
                <EnquiryForm kind="join" testid="join-form" showCity buttonLabel="Request onboarding" />
              </div>
            </div>
          </Reveal>
        </div>
      </div>
    </div>
  );
}
